// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const getCollabServiceUrl = (): string => `${window.location.origin}/jcollab`;
